export default "__VITE_ASSET__62957339__"